module.exports = __webpack_public_path__ + "static/media/FiHR_logo.881d80fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/FiHR_logo.png
// module id = 305
// module chunks = 0